import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import axios from 'axios'
import { ReactSession } from 'react-client-session';
// import InfiniteScroll from "react-infinite-scroller";
import {Helmet} from "react-helmet";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '../Dashboard.css';
import classes from "./Groups.module.css";
import styles from '../Dashboard.module.css';
import 'react-tagsinput/react-tagsinput.css'

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../../Footer/Footer";
import LoadMoreButton from "../../Global/LoadMoreButton";

// import noThumb from "../../../images/no-thumb.jpg";

function Groups() {
    const [groups, setGroups] = useState([]);
    const [hasMore, sethasMore] = useState(true);
    const [page, setpage] = useState(2);
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    ReactSession.setStoreType("localStorage");

    const logged_user = ReactSession.get('logged_user');

    useEffect(() => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/mygroups.php`, {
            uid: logged_user,
            user_id: logged_user,
            action: 'GET_MY_GROUPS'
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => {
            setGroups(res.data);

            res.data.length < 10 ? sethasMore(false) : sethasMore(true);
            setProgress(100);
            setLoading(true);
        })
    } , [])

    const loadMore = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/mygroups.php`, {
            uid: logged_user,
            user_id: logged_user,
            page: page,
            action: 'GET_MY_GROUPS'
            }, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {
                if(res.data.message !== 'No groups found') {
                    loading && hasMore && setGroups(res.data);

                    setpage(page + 1);
                    res.data.length < 10 ? sethasMore(false) : sethasMore(true);
                }else {
                    sethasMore(false)
                }
            })
    }

    const deleteGroup = (id) => {
        const video = document.getElementById(`group_${id}`);
        if(video) {
            if(window.confirm("Are you sure you want to delete this video?")) {
                const toast_id = toast.loading("Please wait...");
                axios.post(`${process.env.REACT_APP_API_URL}/api/user/mygroups.php`, {
                        user_id: logged_user,
                        group_id: id,
                        action: 'DELETE_MY_GROUP'
                    }, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then(res => {
                        toast.update(toast_id, {render: res.data.message, autoClose: 5000, type: res.data.status, isLoading: false});
                        if(res.data.status === 'success') {
                            video.remove();
                        }
                    })
            }
        }else {
            alert("hone");
        }
    }
    return (
        <>
            <Helmet>
                <title>Groups</title>
            </Helmet>
            <div className="container_wrapper">
                <Header />
                <div className={`${styles.main} main`}>
                    <ToastContainer />
                    <Sidebar active="groups" />
                    <div className={styles.main_content}>
                        <div className={styles.content_body}>
                        <div className={classes.page_name}>
                                        <h3>My Groups</h3>
                                    </div>
                                    <div className={styles.card}>
                                        <div className="card-body">
                                            <table className={`table ${classes.table}`}>
                                                <thead>
                                                    <tr>
                                                        <th>Group Thumbnails</th>
                                                        <th>Group Name</th>
                                                        <th className={classes.action}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        groups && groups.map ? groups.map((group, index) => {
                                                            return (
                                                                <tr id={`group_${group.id}`} key={index}>
                                                                    <td><img className={classes.group_thumb} src={group.thumb} alt="" /></td>
                                                                    <td><strong className='text-muted'>{group.groupName}</strong></td>
                                                                    <td>
                                                                        <Link className="btn btn-sm btn-outline btn-info " to={`/dashboard/editgroup/${group.id}`} title="Edit"><i className="icon-edit"></i>Edit</Link>
                                                                        <button className="btn btn-sm btn-outline btn-danger" onClick={() => deleteGroup(group.id)}><i className="icon-trash"></i>Delete</button>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                        : <tr><td colSpan='3' align='center' className='text-muted'>Nothing to see here</td></tr>
                                                    }
                                                </tbody>
                                            </table>
                                            <div style={{display: 'flex', justifyContent: 'center'}}>
                                                {
                                                    hasMore && <span onClick={loadMore}><LoadMoreButton text="Load more..." /></span>
                                                }
                                            </div>
                                        </div>
                                    </div>
                        </div>
                    <Footer />
                    </div>
                </div>
            </div>
        </>
    );
}

export default Groups;